import { DidomiContext } from 'app/app';
import AvatarWithBadge from 'app/common/mobile/avatar-with-badge/avatar-with-badge';
import ErrorModal from 'app/common/mobile/modals/error-modal/error-modal';
import ModalInfo from 'app/common/mobile/modals/modal-info/modal-info';
import ModalRating from 'app/common/mobile/modals/modal-rating/modal-rating';
import { FEED_BACK_ENTITY_TYPE } from 'app/config/constants';
import { DeviceType } from 'app/modules/cms/utils/cms-constants';
import { redirectToLounge } from 'app/modules/externalApp/service/lounge-service';
import { LoungeActionConstants } from 'app/modules/externalApp/utils/lounge-action-constant';
import { gtmEvent, refreshClientId } from 'app/modules/gtm/service/gtm.service';
import {
  computeStepEngineDatas,
  getNextStep,
  getPreviousStep,
  getSpecificStep,
  getSpecificStepFromEvent,
  hideNextButton,
  hidePreviousButton,
  resetStepEngine
} from 'app/modules/step-engine/service/step-engine-service';
import { ModalConstants, PagePart, Step, StepEngineBehaviorsConstants, StepEngineStepGroup } from 'app/modules/step-engine/utils/step-engine-constants';
import { viewsMapping } from 'app/modules/step-engine/utils/step-engine-mappers';
import { componentLoader, getKeyByValue } from 'app/modules/step-engine/utils/step-engine-methods';
import StepActions from 'app/shared/components/desktop/step-action/claim-declare-step-actions';
import StepActionsVertical from 'app/shared/components/desktop/step-action/step-action-vertical';
import StickyRecap from 'app/shared/components/desktop/sticky-recap/sticky-recap';
import { STEP_PREFIX } from 'app/shared/constants/constants';
import ErrorBoundary from 'app/shared/error/error-boundary';
import { FeedBackDTO } from 'app/shared/model/FeedBackDTO.model';
import { IRootState } from 'app/shared/reducers';
import { findSubscriptionByNumber } from 'app/shared/reducers/kubrick-management';
import { isEmptyArray, isEmptyObject } from 'app/shared/util/method-util';
import React, { useContext, useEffect, useState } from 'react';
import { translate } from 'react-jhipster';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import { SpbProgressBar } from 'spb-react-components';
import { createFeedBack } from '../../service/client-service';
import {
  addComponentDataToOneStep,
  addGlobalData,
  addRepeatableGlobalData,
  addStepGroupToOneStep,
  removeDeclarationGlobalData,
  removeRepeatableDeclarationGlobalData,
  removeStepsFromStepListAfterIndex,
  setComponentList,
  setCurrentRepeatableStepGroup,
  setCurrentStep,
  setCurrentStepGroup,
  setLastEditStep,
  setLastRepeatableStepGroup,
  setShowEligibilityModal,
  setShowErrorModal,
  setShowRatingModal,
  setStepEngineDeviceType,
  setStepGroup,
} from '../../service/store/step-engine-dispatchs';
import './claim-declare-steps-engine.scss';
import MobileSkeleton from './mobileSkeleton';
import SkeletonSteps from './skeleton-steps';
import { getCurrentStepIndex } from '../../service/store/step-engine-selectors';
import ScrollToTopButton from 'app/shared/components/desktop/scroll-to-top-button';


export const ClaimDeclareStepsEngine = (props) => {
  const dispatch = useDispatch();
  const didomi = useContext(DidomiContext);
  const { cmsContent, isLoading, isMobile } = useSelector((state: IRootState) => state.cms);
  const { currentSteps, lastEditStep, currentStepGroup, currentRepeatableStepGroup } = useSelector((state: IRootState) => state.stepEngine.stepData);
  const tmpComponents = useSelector((state: IRootState) => state.stepEngine.components);
  const [lastEditStepWithCustomerEntry, setlastEditStepWithCustomerEntry] = useState("");
  const { stepData, globalData, backToHome, goToLoginError, declarationGlobalData, showEligibilityModal, showErrorModal, showRatingModal, components } = useSelector((state: IRootState) => state.stepEngine);
  const { subscriptionNumber, subscriptionDate } = useSelector((state: IRootState) => state.kubrickManagement.subscription || {});
  const { websiteCode, clientWebsite } = useSelector((state: IRootState) => state.appManagement.frontConfig);
  const clientNumberFromStore = useSelector((state: IRootState) => state.kubrickManagement.subscriber?.number);
  const modalCancelBtnAttribute = useSelector((state: IRootState) => state.kubrickManagement.modalCancelBtn);
  const cancelButton = cmsContent[PagePart.POP_IN]?.prismic[modalCancelBtnAttribute]
  const { ratingTitle, ratingText, ratingValidButton } = cmsContent[PagePart.POP_IN]?.prismic || {}
  const modalMsgAttribute = useSelector((state: IRootState) => state.kubrickManagement.modalMsg);
  const modalMsgDescription = cmsContent[PagePart.POP_IN]?.prismic[modalMsgAttribute];
  const { upArrowIcon } = cmsContent[PagePart.APP_GLOBAL_TYPE]?.prismic || {};
  const { claimNumber } = useSelector((state: IRootState) => state.claim);
  const stepList = useSelector((state: IRootState) => state.stepEngine.stepList);
  const currentStepIndexStore = useSelector(getCurrentStepIndex);
  const disableNextButton = currentStepIndexStore > -1 ? stepList[currentStepIndexStore].disableNextButton : false;
  const [currentProgressBar, setCurrentProgressBar] = useState([]);
  const [componentItems, setComponentItems] = useState([]);
  const [showComponents, setShowComponents] = useState(false);
  const { prismic, behaviors } = cmsContent[Step[currentSteps[0]]] || {};
  const { title, information } = prismic || {};
  const {
    prismic: errorModalPrismic,
  } = cmsContent[ModalConstants[behaviors?.[StepEngineBehaviorsConstants.SHOW_MODAL]]] || {};
  const {
    text,
    contactUsLink,
    contactUsMethod,
    contactUsButton,
    closeButton
  } = errorModalPrismic || {}
  const direction = useHistory();
  const urlParams = useParams();
  const [stepListGroup, setStepListGroup] = useState([])
  const [currentShowStepAction, setCurrentShowStepAction] = useState<any>()
  const { verticalDisplay } = useSelector((state: IRootState) => state.appManagement?.frontConfig);
  const isInVerticalDisplay = verticalDisplay && !isMobile;
  const queryString = props.location.search;
  const query = new URLSearchParams(queryString);
  const stepNameQuery = query.get('stepName');
  const claimNumberQuery = query.get('claimNumber');

  const {
    behaviors: lastEditStepBehaviors
  } = cmsContent[lastEditStep] || {}

  const isLastStepInGroup = (
    lastEditStepBehaviors?.progressBar
    &&
    (lastEditStepBehaviors?.progressBar[1] - lastEditStepBehaviors?.progressBar[0] === 1)
  ) || behaviors?.stepGroup === StepEngineStepGroup.SINGLE

  const getViews = () => {
    const tempViews = []
    if (isInVerticalDisplay) {
      if (currentStepGroup && currentStepGroup === "SINGLE") {
        tempViews.push({
          component: stepList[stepList.length - 1].component,
        })
      } else if (currentStepGroup) {
        for (let i = 1; i <= stepList.length - 1; i++) {
          if (stepList[i].stepGroup !== "SINGLE")
            tempViews.push({
              component: stepList[i].component,
              insuredGroupIndex: stepList[i].insuredGroupIndex,
            })
        }
      }
    } else {
      tempViews.push({
        component: componentItems[0],
        // component: stepList[currentStepIndexStore].component,
        insuredGroupIndex: currentRepeatableStepGroup
      })
      // return componentItems
    }
    return tempViews
  }

  const getNextView = () => {
    if (isInVerticalDisplay) {
      dispatch(setLastEditStep(Step[stepData.currentSteps[0]]))
      // pas de getNextStep car useEffect sur lastEditStep
      if (currentStepIndexStore === 0 || Step[stepData.currentSteps[0]] === lastEditStep) {
        dispatch(getNextStep());
      }
    } else {
      console.log("getNextView => NEXT STEP");
      dispatch(getNextStep());
    }
  };

  const startWithSpecificStep = () => {
    if (urlParams['subscriptionNumber'] && claimNumberQuery && stepNameQuery) {
      return true;
    } else {
      return false;
    }
  }
  // ajouter le step dans une liste de step

  // FIXME: à faire au démarrage uniquement !
  useEffect(() => {
    const items = [];
    if (componentItems[0] && isInVerticalDisplay && behaviors?.stepGroup && Step[currentSteps[0]] === componentItems[0]?.props?.dataKey) {
      items.push(Object.assign({ stepReset: true, showStepAction: stepData?.showStepAction }, componentItems[0]))
      if (items !== undefined) {
        dispatch(addComponentDataToOneStep(currentStepIndexStore, items[0]))
      }
      if (!stepList[currentStepIndexStore]?.stepGroup || stepList[currentStepIndexStore]?.stepGroup !== behaviors?.stepGroup) {
        dispatch(addStepGroupToOneStep(currentStepIndexStore, behaviors?.stepGroup))
      }

      dispatch(setCurrentStepGroup(behaviors?.stepGroup))
      if (!stepListGroup.includes(behaviors?.stepGroup)) {
        setStepListGroup([...stepListGroup, behaviors?.stepGroup])
      }
    }
  }, [componentItems, behaviors?.stepGroup]);

  useEffect(() => {
    setCurrentShowStepAction(behaviors?.showStepAction)
  }, [behaviors?.showStepAction])

  const setData = (stepId, dataValue, insuredGroupIndex, bSetLastEditStep = false) => {
    dispatch(computeStepEngineDatas(stepId, dataValue));
    dispatch(insuredGroupIndex === null || insuredGroupIndex === undefined ?
      addGlobalData(stepId, dataValue) : addRepeatableGlobalData(stepId, dataValue, insuredGroupIndex));
    dispatch(setCurrentRepeatableStepGroup(insuredGroupIndex === undefined ? null : insuredGroupIndex))
    dispatch(setLastRepeatableStepGroup(insuredGroupIndex === undefined ? null : insuredGroupIndex))
    !bSetLastEditStep && dispatch(setLastEditStep(stepId));
  };

  const disabledNext = () => {
    const enableNextButton = behaviors?.[StepEngineBehaviorsConstants.ENABLE_NEXT_BUTTON] ?? false;
    if (enableNextButton) return !enableNextButton;

    let hasNullValue = false;

    if (currentStepIndexStore > -1) {
      return disableNextButton
    } else {
      stepData.currentSteps.forEach(currentStep => {
        const value = declarationGlobalData[Step[currentStep]];
        if (typeof value === 'undefined' || value?.length === 0) {
          hasNullValue = true;
        }
      });
    }

    return hasNullValue;
  };

  const refreshGlobalData = (stepIndex, insuredGroupIndex) => {
    for (let i = stepIndex + 1; i < stepList.length; i++) {
      dispatch(removeDeclarationGlobalData(Step[stepList[i].stepName]))
    }
    // Si null -> delete tout
    // Si number -> delete tout après cet index
    // insuredGroupIndex === null || insuredGroupIndex === number
    dispatch(removeRepeatableDeclarationGlobalData(insuredGroupIndex === null ? 0 : insuredGroupIndex + 1))
  }

  // Quand on modifie la même step avec un impact sur la step suivante || qu'on modifie une step qui modifie le customerEntry
  useEffect(() => {
    console.log("UE customerEntry ");
    setlastEditStepWithCustomerEntry(lastEditStep) // getter/setter useState
    if (isInVerticalDisplay
      && getKeyByValue(Step, lastEditStep) !== currentSteps[0]
      && !behaviors?.cover // Si il existe behaviors cover pour surcharge, alors pas de traitement à nouveau car getNextStep à déjà été fait
      && currentStepGroup === 'COVERAGE'
      && lastEditStep
    ) {
      console.log("UE customerEntry IN");

      const multipleCustomerEntries = cmsContent[lastEditStep].behaviors.multipleCustomerEntries;
      const currentStepIndex = stepList.findIndex(x => x.stepName === getKeyByValue(Step, lastEditStep) && x.insuredGroupIndex === stepData.currentRepeatableStepGroup);
      refreshGlobalData(currentStepIndex, stepData.currentRepeatableStepGroup);
      dispatch(setCurrentRepeatableStepGroup(stepList[currentStepIndex].insuredGroupIndex))
      dispatch(setCurrentStep([getKeyByValue(Step, lastEditStep)]))
      dispatch(removeStepsFromStepListAfterIndex(currentStepIndex))

      if (stepData.currentRepeatableStepGroup === null) {
        if (lastEditStepBehaviors?.forceNextStepOnSelection
          || !(globalData[lastEditStep] instanceof Array || typeof globalData[lastEditStep] === 'string') && !multipleCustomerEntries) {
          console.log("UE customerEntry IN NEXT STEP");
          dispatch(getNextStep());
        }
      } else {
        if (globalData["insuredGoods"][stepData.currentRepeatableStepGroup] !== undefined
          && globalData["insuredGoods"][stepData.currentRepeatableStepGroup][lastEditStep] !== undefined) {
          if (lastEditStepBehaviors?.forceNextStepOnSelection
            || !(globalData["insuredGoods"][stepData.currentRepeatableStepGroup][lastEditStep] instanceof Array
              || typeof globalData["insuredGoods"][stepData.currentRepeatableStepGroup][lastEditStep] === 'string')) {
            console.log("UE customerEntry IN NEXT STEP");
            dispatch(getNextStep());
          }
        }
      }
    }
  }, [stepData.journeyData.customerEntry])

  // FIXME: la duplication d'appel vers getNextStep est causé par l'appel des deux useEffect, l'un après l'autre
  // Dernière modification qui a été faite, soit par une action humaine, soit par le code (Drools, nextStep auto, etc ...)
  useEffect(() => {
    console.log("UE lastEditStep");
    if (lastEditStepBehaviors?.resetCover) {
      dispatch(computeStepEngineDatas(Step.COVER_SELECTION, undefined, true));
    }
    console.log("UE lastEditStep", lastEditStep, lastEditStepWithCustomerEntry);
    if (isInVerticalDisplay
      && lastEditStep
      && !(typeof globalData[lastEditStep] === 'string')
      && (!lastEditStepBehaviors?.progressBar
        || (lastEditStepBehaviors?.progressBar
          && (lastEditStepBehaviors?.progressBar[1] - lastEditStepBehaviors?.progressBar[0] !== 1)
        )
      )
      && lastEditStep !== Step.GET_FIRST_STEP
      && lastEditStep !== lastEditStepWithCustomerEntry
    ) {
      console.log("UE lastEditStep IN");
      if (currentStepIndexStore > -1) {
        if (Step[stepData.currentSteps[0]] !== Step.DECLARATION_SUMMARY) {
          refreshGlobalData(currentStepIndexStore, stepData.currentRepeatableStepGroup)
        }
        dispatch(setCurrentRepeatableStepGroup(stepList[currentStepIndexStore].insuredGroupIndex))
      }
      dispatch(setCurrentStep([getKeyByValue(Step, lastEditStep)]))

      if (stepData.currentRepeatableStepGroup === null) {
        if (lastEditStepBehaviors?.isNotRedirect !== true
          && (lastEditStepBehaviors?.forceNextStepOnSelection
            || !(globalData[lastEditStep] instanceof Array)) // TODO: ICIIIII
        ) {
          console.log("UE lastEditStep IN NEXT STEP");
          dispatch(getNextStep());
        }
      } else {
        if (globalData["insuredGoods"][stepData.currentRepeatableStepGroup] !== undefined
          && globalData["insuredGoods"][stepData.currentRepeatableStepGroup][lastEditStep] !== undefined) {
          if (lastEditStepBehaviors?.isNotRedirect !== true &&
            (lastEditStepBehaviors?.forceNextStepOnSelection
              || !(globalData["insuredGoods"][stepData.currentRepeatableStepGroup][lastEditStep] instanceof Array)) // TODO: ICIIIII
          ) {
            console.log("UE lastEditStep IN NEXT STEP");
            dispatch(getNextStep());
          }
        }
      }
    }
  }, [lastEditStep])

  // Animation du fil d'ariane
  useEffect(() => {
    if (!isMobile && behaviors?.progressBar) {
      setTimeout(() => {
        setCurrentProgressBar(behaviors?.progressBar)
      }, 1)
    }
  }, [behaviors?.progressBar, currentSteps])

  // REDIRECTION LOUNGE : INVALIDE_SUBSCRIPTION
  const abandonDeclaration = () => {
    dispatch(gtmEvent("Non éligible", "Fermer", '0'))
    dispatch(redirectToLounge(LoungeActionConstants.NONE));
    dispatch(setShowEligibilityModal(false));
  };

  useEffect(() => {
    if (backToHome) {
      dispatch(redirectToLounge(LoungeActionConstants.NONE));
    }
  }, [backToHome]);

  useEffect(() => {
    if (goToLoginError) {
      direction.push('/login-error');
    }
  }, [goToLoginError]);

  useEffect(() => {
    if (subscriptionNumber) {
      dispatch(addGlobalData('subscriptionNumber', subscriptionNumber));
      dispatch(addGlobalData('subscriptionDate', subscriptionDate));

      if (startWithSpecificStep()) {
        dispatch(getSpecificStepFromEvent({ stepName: stepNameQuery, claimNumber: claimNumberQuery }));
      } else {
        console.log("UE subscriptionNumber => NEXT VIEW");
        getNextView();
      }
    }
  }, [subscriptionNumber]);

  useEffect(() => {
    if (clientNumberFromStore) {
      dispatch(addGlobalData('clientNumber', clientNumberFromStore));
    }
  }, [clientNumberFromStore]);

  useEffect(() => {
    if (didomi) {
      dispatch(gtmEvent('Initialisation session', 'Validé', '0'))
    }
  }, [didomi]);



  useEffect(() => {
    if (isMobile !== null) {
      dispatch(resetStepEngine());
      dispatch(setStepEngineDeviceType(isMobile ? DeviceType.MOBILE : DeviceType.DESKTOP));
      if (!urlParams['subscriptionNumber']) {
        refreshClientId();
        getNextView();
      } else {
        if (urlParams['subscriptionNumber']) {
          history.pushState(null, null, location.href);
          window.onpopstate = function (event) {
            history.go(1);
          };

          refreshClientId();
          dispatch(findSubscriptionByNumber(urlParams['subscriptionNumber']));
        }
      }
    }
    return () => {
      dispatch(resetStepEngine());
    };

  }, [isMobile]);


  useEffect(() => {
    setShowComponents(
      !isEmptyArray(componentItems)
      &&
      !isEmptyObject(prismic)
      &&
      (!behaviors?.[StepEngineBehaviorsConstants.SHOW_MODAL] || !isEmptyObject(errorModalPrismic))
    );
  }, [componentItems, cmsContent]);

  const setErrorModal = (value: boolean) => {
    dispatch(setShowErrorModal(value));
  };

  // TODO: y'a plus qu'à
  const getPreviousView = () => {
    if (isInVerticalDisplay) {
      const indexGroup = stepListGroup.indexOf(currentStepGroup);
      dispatch(setCurrentStepGroup(stepListGroup[indexGroup - 1]));
      dispatch(setStepGroup(stepListGroup[indexGroup - 1]));
    }
    dispatch(getPreviousStep());
  };

  const getSpecificView = specificStep => {
    dispatch(getSpecificStep(specificStep));
  };

  const closeModal = () => {
    dispatch(setShowEligibilityModal(false));
  }
  const ratingData = (data) => {
    const feedBackDTO: FeedBackDTO = {
      comments: data?.comment,
      entity: {
        type: FEED_BACK_ENTITY_TYPE.CLAIM,
        value: claimNumber
      },
      rating: data?.rating,
      webSiteCode: websiteCode,
      accountId: null
    }
    dispatch(createFeedBack(feedBackDTO));
    dispatch(setShowRatingModal(false));
  };
  const closeModalRating = () => {
    dispatch(setShowRatingModal(false));
  }


  const initializeViews = () => {
    const views = new Map();
    viewsMapping.forEach((value: string, key: Step) => {
      const Component = componentLoader(value);
      views.set(
        key,
        <Component
          dataKey={key}
          getNextStep={getNextView}
          getSpecificStep={getSpecificView}
          setGlobalData={setData} // TODO: rename
          getPreviousStep={getPreviousView}
        />
      );
    });
    dispatch(setComponentList(views))
  };


  const redirectToClienWebSite = () => {
    window.location.href = clientWebsite;
  }
  const closeDeclaration = () => {
    location.reload();
  }

  const checkRedirectToHome = () => {
    if (Step[behaviors?.[StepEngineBehaviorsConstants.MODAL_HANDLE_BACK_TO_HOME]] === Step.GET_FIRST_STEP) {
      dispatch(resetStepEngine())
      getNextView();
    }
    if (StepEngineBehaviorsConstants[behaviors?.[StepEngineBehaviorsConstants.MODAL_HANDLE_BACK_TO_HOME]] === StepEngineBehaviorsConstants.REDIRECT_TO_LOUNGE) {
      dispatch(redirectToLounge(LoungeActionConstants.NONE));
    }
    if (StepEngineBehaviorsConstants[behaviors?.[StepEngineBehaviorsConstants.MODAL_HANDLE_BACK_TO_HOME]] === StepEngineBehaviorsConstants.REDIRECT_TO_CLIENT_WEB_SITE) {
      // TODO : A voir coment gerer le lien de redirection
      redirectToClienWebSite();
    }
    if (StepEngineBehaviorsConstants[behaviors?.[StepEngineBehaviorsConstants.MODAL_HANDLE_BACK_TO_HOME]] === StepEngineBehaviorsConstants.REFRESH_DECLARATION) {
      // TODO : A voir coment gerer le lien de redirection
      closeDeclaration();
    }
  }

  const handleModalErrorClose = () => {
    if (behaviors?.[StepEngineBehaviorsConstants.HANDLE_PREVIOUS_STEP_ON_MODAL_CLOSE]) {
      getPreviousView();
    }
    if (Step[behaviors?.[StepEngineBehaviorsConstants.HANDLE_BACK_TO_HOME_ON_MODAL_CLOSE]] === Step.GET_FIRST_STEP) {
      dispatch(resetStepEngine())
      getNextView();
    }
    if (StepEngineBehaviorsConstants[behaviors?.[StepEngineBehaviorsConstants.HANDLE_BACK_TO_HOME_ON_MODAL_CLOSE]] === StepEngineBehaviorsConstants.REDIRECT_TO_LOUNGE) {
      dispatch(redirectToLounge(LoungeActionConstants.NONE));
    }
  }

  const handleContactUs = () => {
    if (behaviors?.[StepEngineBehaviorsConstants.HANDLE_CONTACT_US_LOUNGE]) {
      dispatch(redirectToLounge(LoungeActionConstants.CONTACT_FORM));
    }
  }

  const handleHideClose = (): boolean => {
    return behaviors?.[StepEngineBehaviorsConstants.HANDLE_HIDE_CLOSE_MODAL]
  }

  useEffect(() => {
    if (Object.keys(tmpComponents).length === 0)
      initializeViews();
  }, [tmpComponents])

  useEffect(() => {
    if (currentSteps.length) {
      const items = [];
      currentSteps.map(item => {
        const componentItem = tmpComponents[Step[item]];
        items.push(componentItem);
      });
      setComponentItems(items);
      if (isInVerticalDisplay) {
        if (items[0] !== undefined) {
          if (!stepList[currentStepIndexStore]?.component || stepList[currentStepIndexStore]?.component.props.dataKey !== items[0].props?.dataKey) {
            dispatch(addComponentDataToOneStep(currentStepIndexStore, items[0]))
          }
          if (!stepList[currentStepIndexStore]?.stepGroup || stepList[currentStepIndexStore]?.stepGroup !== currentStepGroup) {
            dispatch(addStepGroupToOneStep(currentStepIndexStore, currentStepGroup))
          }
        }
      }
    }
  }, [currentSteps]);

  const hideBackButton = () => {
    return hidePreviousButton(cmsContent, currentSteps[0]);
  };

  const hideForwardButton = () => {
    return hideNextButton(cmsContent, currentSteps[0]);
  };


  const stepActionButton = () => {
    if (currentShowStepAction || !isInVerticalDisplay) {
      return (
        prismic && (
          <StepActions
            hidePreviousButton={hideBackButton}
            hideNextButton={hideForwardButton}
            getPreviousView={getPreviousView}
            getNextView={getNextView}
            disabledNext={disabledNext()}
            previousLabel={prismic?.previousButton}
            nextLabel={prismic?.nextButton}
          />
        ))
    } else if (currentShowStepAction === undefined && isInVerticalDisplay) {
      const isNotRedirect = behaviors?.isNotRedirect ?? false
      if (isNotRedirect === true) {
        return (
          <StepActionsVertical
            getNextView={getNextView}
            disabledNext={disabledNext()}
          />
        );
      }
    } else {
      return
    }
  }

  return (
    <>
      <ErrorBoundary>
        {!isMobile && (isLoading || !showComponents) && isLastStepInGroup ?
          <SkeletonSteps />
          :
          <>
            {showComponents &&
              <>
                {isMobile ? isLoading ?
                  <MobileSkeleton steps={currentSteps} />
                  :
                  <>
                    <AvatarWithBadge
                      hideButton={hideBackButton()}
                      getPreviousStep={getPreviousView}
                      title={title ? Array.isArray(title) ? title : [title] : []}
                      text={!behaviors?.isUnique ? (information ? [information] : []) : []}
                    />
                    {getViews().map((stepView: any, key) => {
                      if (stepView.component !== undefined)
                        return (<>
                          {React.cloneElement(
                            stepView.component, {
                            insuredGroupIndex: stepView.insuredGroupIndex
                          })}
                        </>)
                    })}

                  </>
                  :
                  <>
                    {(isInVerticalDisplay && !behaviors?.hideStickyRecap && behaviors?.stepGroup !== StepEngineStepGroup.SINGLE) &&
                      <StickyRecap questions={getViews()}></StickyRecap>
                    }
                    <div className={`claim-declaration ${(isInVerticalDisplay && currentSteps[0] === "DECLARATION_SUMMARY") && "declaration-summary"}`}>
                      {!isInVerticalDisplay &&
                        <SpbProgressBar color="#0092d4" currentProgressBar={currentProgressBar[0]} maxProgressBar={currentProgressBar[1]} />
                      }
                      <div className="steps-container">
                        {(!isInVerticalDisplay || (currentStepGroup && stepList.findIndex(x => x.stepGroup === currentStepGroup) !== -1)) &&
                          getViews().map((stepView: any, key) => {
                            const { dataKey } = stepView.component?.props;
                            return (
                              <React.Fragment key={key}>
                                <div className="step-container" id={STEP_PREFIX + dataKey + (stepView.insuredGroupIndex != null ? stepView.insuredGroupIndex : "")}>
                                  <AvatarWithBadge
                                    hideButton={true}
                                    getPreviousStep={getPreviousView}
                                    title={cmsContent[dataKey]?.prismic?.title ? Array.isArray(cmsContent[dataKey]?.prismic?.title) ? cmsContent[dataKey]?.prismic?.title : [cmsContent[dataKey]?.prismic?.title] : []}
                                    text={cmsContent[dataKey]?.prismic?.information ? [cmsContent[dataKey]?.prismic?.information] : []}
                                  />
                                  {React.cloneElement(
                                    stepView.component, {
                                    insuredGroupIndex: stepView.insuredGroupIndex
                                  })}
                                </div>
                              </React.Fragment>
                            );
                          })}
                        {prismic && stepActionButton()}
                        {isInVerticalDisplay && (isLoading || !showComponents) &&
                          (!lastEditStepBehaviors?.progressBar || (lastEditStepBehaviors?.progressBar && (lastEditStepBehaviors?.progressBar[1] - lastEditStepBehaviors?.progressBar[0] !== 1)))
                          &&
                          <SkeletonSteps />
                        }
                      </div>
                    </div>
                    {upArrowIcon &&
                      <ScrollToTopButton
                        className='scroll-to-top-button'
                        threshold={300}
                        iconSrc={upArrowIcon}
                      />
                    }
                    {isInVerticalDisplay && (isLoading || !showComponents) &&
                      (!lastEditStepBehaviors?.progressBar || (lastEditStepBehaviors?.progressBar && (lastEditStepBehaviors?.progressBar[1] - lastEditStepBehaviors?.progressBar[0] !== 1)))
                      &&
                      <div className='page-blocker'></div>
                    }
                  </>
                }
                {!isEmptyObject(errorModalPrismic) && (
                  <ErrorModal
                    message={text}
                    link={contactUsLink}
                    method={contactUsMethod}
                    txtLink={contactUsButton}
                    txtButton={closeButton}
                    checkRedirectToHome={checkRedirectToHome}
                    modal={showErrorModal}
                    setModal={setErrorModal}
                    handleModalClose={handleModalErrorClose}
                    handleContactUs={handleContactUs}
                    hideClose={handleHideClose()}
                  />
                )}
                <ModalInfo
                  modal={showEligibilityModal}
                  setModal={closeModal}
                  handleOk={abandonDeclaration}
                  message={[modalMsgDescription, translate("settings.redirect.lounge")]}
                  txtValidButton={cancelButton}
                />
                <ModalRating
                  modal={showRatingModal}
                  title={ratingTitle}
                  message={[ratingText]}
                  txtValidButton={ratingValidButton}
                  handleOk={ratingData}
                  handleCancel={closeModalRating} />
              </>
            }
          </>
        }
      </ErrorBoundary >
    </>
  );
};

export default ClaimDeclareStepsEngine;
